import { configureStore } from '@reduxjs/toolkit';
import tagReducer from './pages/slice';

const store = configureStore({
  reducer: {
    tag: tagReducer,
  },
});

export default store;